import { render, staticRenderFns } from "./LevelUpDialog.vue?vue&type=template&id=5e6deb23&scoped=true"
import script from "./LevelUpDialog.vue?vue&type=script&lang=ts"
export * from "./LevelUpDialog.vue?vue&type=script&lang=ts"
import style0 from "./LevelUpDialog.vue?vue&type=style&index=0&id=5e6deb23&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e6deb23",
  null
  
)

export default component.exports